<template>
  <div class="bodydiv">
    <el-row class="title">上海市体育局党建及干部培训信息化平台</el-row>
    <!-- <el-row> -->
    <el-row class="mainbox">
      <el-row type="flex" justify="center" align="middle" class="contBox">
        <el-card class="box-card login-card">
          <img src="./dxwkt.png" alt="党校微课堂icon" class="dxwkt" />
          <!-- <el-button type="primary" @click="goLogin">登陆党校微课堂管理系统</el-button> -->
          <button @click="goLogin" class="clickLogin">登陆党校微课堂管理系统</button>
        </el-card>
        <el-card class="box-card login-card">
          <img src="./fxyh.png" alt="复兴一号icon" class="fxyh" />
          <!-- <el-button type="primary" plain @click="goFuxin">登录复兴一号管理系统</el-button> -->
          <button @click="goFuxin" class="clickLogin">登录复兴壹号管理系统</button>
        </el-card>
      </el-row>
    </el-row>
    <div class="bottomTxt">
      <p id="lasttitle">党校微课堂 版权所有</p>
      <p id="lasttitle">为了更好的使用体验，建议使用Chrome等主流浏览器</p>
    </div>
    <!-- </el-row> -->
  </div>
</template>

<script>
export default {
  name: "LoginEntrance",
  
  methods: {
    goLogin() {
      this.$router.push("login");
    },
    
    goFuxin() {
      window.location.href = "https://fuxing1.boc.cn";
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.changeButton {
  display: block;
  color: #767676;
  position: absolute;
  z-index: 1001;
  right: 20%;
  bottom: 33%;
}
.changeButton:hover {
  color: #409eff;
  cursor: pointer;
}
/* 获取验证码 */
.getCode {
  width: 98px;
  text-align: center;
}
.getCode:hover {
  cursor: pointer;
}

.login-card {
  width: 298px;
  height: 298px;
  border-radius: 15px;
  padding: 0;
  position: relative;
}
.login-card >>> div {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;
}
.login-card .dxwkt {
  width:126px;
  height: 94px;
  margin-top: 75px;
}
.login-card .fxyh {
  width: 94px;
  height: 156px;
  margin-top: 40px;
}
.login-card .clickLogin {
  border: none;
  color: #fff;
  background: linear-gradient(90deg, #ec363c, #ff8c71);
  border-radius: 10px;
  width: 270px;
  height: 46px;
  font-size: 16px;
  letter-spacing: 3px;
  outline: none;
  cursor: pointer;
  position: absolute;
  bottom: 14px;
}

.mainbox {
  width: 700px;
  margin: 0 auto;
}
.mainbox .contBox {
  display: flex;
  justify-content: space-between;
  margin-top: 85px;
}
.login-card .main {
  height: 250px;
  padding-top: 20px;
  padding-left: 10px;
  padding-right: 10px;
  /* margin-top: 30px; */
  /* margin-bottom: 50px; */
}

.login-title {
  width: 15%;
  min-width: 80px;
  max-width: 120px;
  text-align: right;
  margin-right: 30px;
}

.input-comp {
  /* width: 50%; */
  min-width: 260px;
  max-width: 300px;
}

.bodydiv {
  position: absolute;
  width: 100%;
  height: 100%;
  /* background: url("https://shsportshistory.oss-cn-hangzhou.aliyuncs.com/shsportshistory/login.jpg"); */
  background: url("login.jpg") no-repeat;
  background-size: 100% 100%;
  background-position: center;
}
.title {
  color: #fdca00;
  font-size: 35px;
  font-weight: 800;
  letter-spacing: 5px;
  text-align: center;
  margin-top: 225px;
}
.handlediv {
  padding-top: 30px;
  border-top: 1px solid #ebeef5;
  display: flex;
  justify-content: center;
  align-items: center;
}

.error-div {
  text-align: center;
}

/* .login-row { */
/* padding-right: 40px; */
/* } */

#title {
  color: white;
  font-weight: bold;
  font-size: 36px;
  line-height: 0px;
}

#subtitle {
  color: white;
  font-size: 24px;
  line-height: 0px;
}

#lasttitle {
  color: #ff3332;
  font-size: 16px;
  line-height: 0px;
  font-weight: 400;
  line-height: 20px;
  opacity: 0.8;
}

.login-form-title {
  font-size: 14px;
  font-family: "Microsoft YaHei", "微软雅黑", "Helvetica Neue", Helvetica,
    "PingFang SC", "Hiragino Sans GB", Arial, sans-serif;
}

.login-card .tips {
  padding-top: 10px;
  /* font-size: 13px; */
}

.tips p {
  font-size: 13px;
}
.bottomTxt {
  position: absolute;
  bottom: 28px;
  width: 100%;
  text-align: center;
}
</style>
